var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"30px 0"}},[_c('img',{staticStyle:{"width":"40px"},attrs:{"src":"/static/images/null.png"}}),_c('div',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }